<template>
    <div>
        <div class="header-tool">
            <input @input="handleSearchInput" class="form-control search-input" />
            <el-button size="mini" @click.native="download"><i class="glyphicon glyphicon-download-alt"></i></el-button>
        </div>
        <t-table
            id="mainTable"
            :data="tableData.data"
            :pageSize="queryTableParams.pageSize"
            :curPage="queryTableParams.pageNum"
            :total="tableData.total"
            @current-change="handleTableCurrentChange"
            @sort-change="handleSortable"
            @size-change="handleTablePageSize"
        >
            <t-table-column label="DAID" property="daid" width="3%" sortable/>
            <t-table-column label="Reported Trait" property="reportedTrait" width="10%" sortable/>
            <t-table-column label="Trait Label" property="efoOntologyTrait" width="12%" sortable/>
            <t-table-column label="Trait Ontology ID" property="efoCode" width="6%" sortable/>
            <t-table-column label="Sample Size" property="sampleSize" width="6%" sortable/>
            <t-table-column label="Population" property="population" width="6%" sortable/>
            <t-table-column label="GWAS Summary Statistics Download" property="publicationCount" width="6%" >
                <a slot-scope="{ row }" :href="row.link" target="_blank"><i class="glyphicon glyphicon-download-alt"></i></a>
            </t-table-column>
        </t-table>
    </div>
</template>

<script>
import table_mix from "@/common/table_mix";
export default {
    name: "trait_summary",

    mixins: [table_mix],

    props: {
        traitId: String,
    },

    data() {
        return {};
    },

    created() {
        this.refreshTable();
    },

    computed: {
        getTableDataAjaxUrl() {
            return `trait/${this.traitId}/summary/page`;
        },
    },

    methods: {
        download() {
            window.open(`/api/trait/${this.traitId}/summary/export?keyword=${this.queryTableParams.keyword}`, '_blank')
        },
    },
};
</script>

<style scoped></style>
